import React, { memo } from 'react'
import FullWidthCarouselWithAnalytics from 'components/WithAnalytics/Carousel/FullWidthCarouselWithAnalytics'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import HeroOfferLoadingCarouselItems from './HeroOfferLoadingCarouselItems'
import { LFSEOfferType } from 'home/components/LookingForSomethingElse/constants'

interface Props {
  offerIds: string[];
  tileStyle?: 'search' | 'hero' | 'frontpage';
  hasLFSETile?: boolean;
  offerType?: LFSEOfferType;
  link?: string;
}

function HeroOfferLoadingCarousel({ offerIds, tileStyle, hasLFSETile, offerType, link }: Props) {
  return (
    <>
      <CSSBreakpoint max="mobile">
        <FullWidthCarouselWithAnalytics snap="start" gap={16}>
          <HeroOfferLoadingCarouselItems offerIds={offerIds} tileStyle={tileStyle} hasLFSETile={hasLFSETile} offerType={offerType} link={link} />
        </FullWidthCarouselWithAnalytics>
      </CSSBreakpoint>
      <CSSBreakpoint min="tablet">
        <FullWidthCarouselWithAnalytics snap="start" >
          <HeroOfferLoadingCarouselItems offerIds={offerIds} tileStyle={tileStyle} hasLFSETile={hasLFSETile} offerType={offerType} link={link} />
        </FullWidthCarouselWithAnalytics>
      </CSSBreakpoint>
    </>
  )
}

export default memo(HeroOfferLoadingCarousel)
